<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Iconos
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/LOGO ITALVEN.png', style='height: auto;width: 160px;border-radius:5px;padding:5px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Cobros
    v-dialog(v-model='dialog7', persistent max-width='1000px')
          v-container(style='background-color:white !important;max-width: 1000px;')
            v-card-title.justify-center
              span.headline Cobro
            div(style="margin-top: 10px;" v-if='itemMov')
              v-flex(xs12, sm12, md12)
                v-layout(align-start='' justify-center='' row='' wrap='' fill-height='')
                  v-flex(xs4 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Nro:
                      span {{itemMov.nro}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Fecha:
                      span {{transform2(itemMov.fechaC)}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Fecha de pago:
                      span {{transform(itemMov.fechaP)}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Tasa:
                      span(v-if='itemMov.tasa') {{itemMov.tasa}}
                      span(v-else) N/A
                  v-flex(xs5 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Vendedor:
                      span {{itemMov.vendedor}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Cliente:
                      span(v-if='itemMov.cliente && itemMov.cliente.cli_des') {{itemMov.cliente.cli_des}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Titular:
                      span(v-if='itemMov.titular') {{itemMov.titular}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') Método:
                      span {{itemMov.metodo}}
                  v-flex(xs3 style='font-size: 14px;')
                    div
                      span(style='font-weight:500;padding-right:3px;') Monto:
                      span {{itemMov.monto}}
                    div
                      span(style='font-weight:500;padding-right:3px;') Referencia:
                      span(v-if='itemMov.referencia') {{itemMov.referencia}}
                      span(v-else) N/A
                    div
                      span(style='font-weight:500;padding-right:3px;') N° Cobro:
                      span(v-if='itemMov.nroCobro') {{itemMov.nroCobro}}
                      span(v-else) N/A
            v-card-title.justify-center
              span.headline Posibles movimientos asociados
            div(style="margin-top: 10px;")
              v-flex(xs12, sm12, md12)
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  v-flex(xs12)
                    v-form(enctype="multipart/form-data")

                      v-data-table.elevation-1(v-model="selectMov" :single-select="true" item-key="_id" :headers='headersMov' :pagination.sync="paginationMov" :items="resultadosMov" style="margin-top: 5px;")
                        template(slot='items', slot-scope='props')
                          td
                            v-checkbox(
                              :value='props.item'
                              style='margin: 0px;padding: 0px;'
                              hide-details=''
                              v-model="selectMov"
                            )
                          td {{ transform(props.item.fecha)}}
                          td {{ props.item.descripcion }}
                          td {{ props.item.banco }}
                          td {{ props.item.monto }}
                          td {{ props.item.referencia }}
                          td {{ props.item.estatus }}

                      div
                        v-flex(v-if="loading === true", xs12 sm12 md12)
                          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                            v-progress-circular(indeterminate='', color='primary')
                        v-flex(v-if="loading === false", xs12 sm12 md12)
                          v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                              v-btn(v-if='selectMov && selectMov.length > 0' style="background:green;border-radius:10px;", @click.native='editItemAproMov') Guardar
                              v-btn(style="background:black;border-radius:10px;", @click.native='closeMov') Salir
    v-dialog(v-model='dialog3', persistent max-width='70%')
      v-card
        v-card-text
          v-container(id="printJS-form")
            div(align='center')
              h4(style='font-weight: 700 !important;') COBRO
            br
            div(style='display: flex;justify-content: space-between;align-items: center;')
              img(src='../assets/LOGO ITALVEN (1).png', style='height: auto;width:120px;object-fit:contain;')
              table(border="0" align="center")
                tr
                  td(align='end').withTd
                    span.paddText N° COBRO
                  td.borderTb
                    span.withTd3 {{form.nro}}
                tr
                  td(align='end').withTd
                    span.paddText FECHA
                  td.borderTb
                    span.withTd3 {{form.fechaC}}
                tr
                  td(align='end').withTd
                    span.paddText EMPRESA
                  td.borderTb
                    span.withTd3 {{form.empresa}}
            table(border="0" align="center" style='width: 100%;margin-top: 20px;')
              tr
                td(align='center').withTd2
                  span MÉTODO DE PAGO
                td(align='center').withTd2
                  span {{form.metodo}}
              tr
                td(align='center').withTd2
                  span VENDEDOR
                td(align='center').withTd2
                  span {{form.vendedor}}
              tr
                td(align='center').withTd2
                  span CLIENTE
                td(align='center').withTd2
                  span {{form.cliente.cli_des}}
              tr
                td(align='center').withTd2
                  span TITULAR
                td(align='center').withTd2
                  span(v-if="form.titular && form.titular !== 'null'") {{form.titular}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span FACTURAS
                td(align='center').withTd2
                  span(v-if="form.fact && form.fact.length > 0") {{form.fact}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span MONTO
                td(align='center').withTd2
                  span(v-if="form.monto") {{form.monto.toFixed(2)}}
                  span(v-else) 0
              tr
                td(align='center').withTd2
                  span REFERENCIA
                td(align='center').withTd2
                  span(v-if="form.referencia && form.referencia !== 'null'") {{form.referencia}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span OBSERVACIÓN
                td(align='center').withTd2
                  span(v-if="form.observacion && form.observacion !== 'null'") {{form.observacion}}
                  span(v-else) N/A
              tr
                td(align='center').withTd2
                  span DESCRIPCIÓN
                td(align='center').withTd2
                  span(v-if="form.descripcion && form.descripcion !== 'null'") {{form.descripcion}}
                  span(v-else) N/A

            div(v-if='form.bacuhe || form.bauche2').divCli
              span IMAGENES
            table(v-if='form.bacuhe || form.bauche2' border="0" align="center" style='width: 100%;margin-top:10px;')
              tr
                td(align='center' v-if='form.bacuhe')
                  div(style='margin:5px;')
                    img(:src='ruta + form.bacuhe', style='height: 250px;object-fit: contain;width: auto;')
                td(align='center' v-if='form.bauche2')
                  div(style='margin:5px;')
                    img(:src='ruta + form.bacuhe2', style='height: 250px;object-fit: contain;width: auto;')

        v-card-actions
          v-spacer
          v-btn(color='error' small dark @click='close3()')
            v-icon mdi-close
            | Cancelar
          v-btn(color='success' small dark @click="imprimirPdf()")
            v-icon mdi-content-save
            | PDF  
    v-dialog(v-model='dialog2', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")
                            
                            v-text-field(outline
                            v-model="form.monto"
                            prepend-inner-icon="description"
                            label="Monto:")
                            
                            v-text-field(
                            outline
                            v-model="form.referencia"
                            prepend-inner-icon="description"
                            label="Referencia:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:red;border-radius:10px;", @click.native='save2()') Modificar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close2') Salir
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Cobro
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md8)
                          v-form(enctype="multipart/form-data")

                            
                            v-text-field(outline
                            readonly
                            v-model="form.metodo"
                            prepend-inner-icon="description"
                            label="Método de pago:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.vendedor"
                            prepend-inner-icon="description"
                            label="Vendedor:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.cliente.cli_des"
                            prepend-inner-icon="description"
                            label="Cliente:")
                            
                            v-text-field(outline
                            v-if='form.titular'
                            readonly
                            v-model="form.titular"
                            prepend-inner-icon="description"
                            label="Titular:")
                            
                            v-select(outline
                            readonly
                            :items='itemsF'
                            multiple
                            v-model="form.facturas"
                            prepend-inner-icon="description"
                            label="Facturas:")
                            
                            v-text-field(outline
                            readonly
                            v-model="form.monto"
                            prepend-inner-icon="description"
                            label="Monto:")

                            v-text-field(outline
                            v-if='form.tasa'
                            readonly
                            v-model="form.tasa"
                            prepend-inner-icon="description"
                            label="Tasa:")
                            
                            v-text-field(v-if='form.referencia'
                            outline
                            readonly
                            v-model="form.referencia"
                            prepend-inner-icon="description"
                            label="Referencia:")
                            
                            v-textarea(outline
                            readonly
                            v-model="form.descripcion"
                            prepend-inner-icon="description"
                            label="Descripción:")

                            div(style='display: flex;justify-content: center;margin: 10px;' v-if='form.bauche')
                              a(:href='ruta + form.bauche' target='_blank')
                                img(:src='ruta + form.bauche' style='width: 425px;height: auto;')

                            div(style='display: flex;justify-content: center;margin: 10px;' v-if='form.bauche2')
                              a(:href='ruta + form.bauche2' target='_blank')
                                img(:src='ruta + form.bauche2' style='width: 425px;height: auto;')

                            v-text-field(outline
                              v-if='form.nroCobro'
                              readonly
                              v-model="form.nroCobro"
                              prepend-inner-icon="description"
                              label="Nro. de cobro:")

                            v-text-field(outline
                              v-if='form.nroADEL'
                              readonly
                              v-model="form.nroADEL"
                              prepend-inner-icon="description"
                              label="Nro. ADEL:")

                            v-textarea(outline
                              v-if='form.observacion'
                              readonly
                              v-model="form.observacion"
                              prepend-inner-icon="description"
                              label="Observación:")

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    //- v-btn(v-if='form.estatus === "Aprobado" || form.estatus === "Conciliado"' style="background:green;border-radius:10px;", @click.native='save("P")') Procesado
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:green;border-radius:10px;", @click.native='save("A")') Aprobar
                                    v-btn(v-if='form.estatus === "Pendiente"' style="background:red;border-radius:10px;", @click.native='save("R")') Rechazar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-flex(xs12 style='margin-top: 5px;')
          v-layout(wrap style='justify-content: space-between;')
            v-flex(xs4)
              v-text-field(v-model='search', label='Buscar')
            v-flex(xs4 style='display: flex;justify-content: center;padding-left:20px;')
              v-select(:items='filtros' v-model="seleccionFiltro" label="Estatus" @change='cambiarFiltro()')
            v-flex(xs4 style='display: flex;align-items: center;justify-content: flex-end;')
              //- v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
              //-   template(v-slot:activator='{ on, attrs }')
              //-     v-text-field(v-model='dateFormatted' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' @blur='date = parseDate(dateFormatted)' v-on='on')
              //-   v-date-picker(v-model='date' no-title='' @input='modal = false' dark='')
              v-menu(ref='menu1' v-model='modal' :close-on-content-click='false' transition='scale-transition' offset-y='' max-width='450px' min-width='450px')
                template(v-slot:activator='{ on, attrs }')
                  v-text-field(v-model='dateRangeText' label='Fecha' style='padding-left: 15px;' persistent-hint='' v-bind='attrs' v-on='on')
                v-date-picker(multiple v-model='dates' no-title='' dark='')
                  v-spacer
                  v-btn(text='' color='primary' @click='$refs.menu1.save(dates)')
                    | OK
              v-btn.mx-0(icon @click='buscarFecha' style='background: white;border-radius: 100%;margin-left:10px !important;').elevation-4
                v-icon(color='#048420' style='font-size: 1.70rem;') search
              vue-excel-xlsx( v-if='resultados && resultados.length > 0' :data='dataExcel' :columns='columnsExcel' :filename="'Italven-Cobros'" :sheetname="'sheetname'")
                img(src='../assets/iconos/excel.png', style='height: 60px;width: auto;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
          v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
            span.white--text Lista de Cobros
        v-data-table.elevation-1(:headers='headers' :pagination.sync="pagination" :search='search' :items="resultados" style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ props.item.nro }}
            td(v-if='props.item.empresa') {{ props.item.empresa}}
            td(v-else) N/A
            td {{ transform(props.item.fechaC)}}
            td {{ transform(props.item.fechaP)}}
            td {{ props.item.vendedor }}
            td(v-if='props.item.cliente && props.item.cliente.cli_des') {{ props.item.cliente.cli_des }}
            td(v-else) N/A
            td {{ props.item.metodo }}
            td {{ props.item.monto}}
            td(v-if='props.item.referencia') {{ props.item.referencia}}
            td(v-else) N/A
            td(v-if='props.item.nroCobro') {{ props.item.nroCobro}}
            td(v-else) N/A
            td(style='font-weight: bold;' :style="{ color: props.item.estatus == 'Aprobado' ? 'green' : props.item.estatus == 'Rechazado' ? 'red' : 'black'}") {{ props.item.estatus}}
            td.justify-start.layout.px-0
              v-tooltip(v-if='mod' bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem(props.item)' v-on="on" color='teal') edit
                | Editar.
              v-tooltip(v-if='mod && props.item.estatus == "Pendiente"' bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem2(props.item)' v-on="on" color='teal') add_box
                | Modificar referencia.
              v-tooltip(bottom)
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='editItem3(props.item)' v-on="on" color='teal') description
                | Exportar pdf.
              v-tooltip(bottom v-if='mod && props.item.estatus === "Pendiente" && props.item.metodo !== "Efectivo" && !props.item.coincide')
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='buscarMovAso(props.item, "C")' v-on="on" color="blue") description
                | Conciliar.
              v-tooltip(bottom v-if='mod && props.item.estatus === "Pendiente" && props.item.metodo !== "Efectivo" && props.item.coincide')
                template(v-slot:activator='{ on }')
                  v-icon.mr-2(@click='buscarMovAso(props.item, "C")' v-on="on" color="black") description
                | Conciliar.
  //===========================================================Modal Espera==============================================================================================
  v-dialog(v-model='dialog4', persistent max-width='400px' style='background:#f1f2f1')
    v-container(style='max-width: 400px;background:#f1f2f1')
      div(style="margin-top: 20px;")
          v-flex(xs12 sm12)
            v-layout(align-start='', justify-center='', row='', wrap fill-height='')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h4.black--text  Esperando Respuesta del Servidor.!!
              v-flex(xs12)
                  div(style='display: flex;justify-content: center;').text-xs-center
                    img(src='../assets/waiting.gif', with='200' ,height='150')
              v-flex(xs12)
                v-card-title(style="padding: 7px;").justify-center
                  h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
import printJS from 'print-js'
export default {
  name: "Cobros",
  data: vm => ({
    ruta: serverImg,
    dates: [],
    loading: false,
    dialog3: false,
    dialog4: false,
    dialog7: false,
    dialog2: false,
    itemMov: null,
    typeMov: null,
    selectMov: [],
    resultadosMov: [],
    resultadosMovAll: [],
    paginationMov: {
      sortBy: 'fecha', // The field that you're sorting by
      descending: true
    },
    headersMov: [
      { text: "Check", value: "check" },
      { text: "Fecha", value: "fecha" },
      { text: "Descripción", value: "descripcion" },
      { text: "Banco", value: "banco" },
      { text: "Monto", value: "monto" },
      { text: "Referencia", value: "referencia" },
      { text: "Estatus", value: "estatus" }
    ],
    seleccionFiltro: 'todos',
    filtros: [
      {
        text: "Todos",
        value: "todos"
      },
      {
        text: "Pendientes",
        value: "Pendiente"
      },
      {
        text: "Aprobados",
        value: "Aprobado"
      },
      {
        text: "Rechazados",
        value: "Rechazado"
      },
      {
        text: "Procesados",
        value: "Procesado"
      },
    ],
    itemsF: [],
    dataExcel: [],
    columnsExcel: [
      {
        label: "Nro",
        field: "nro",
      },
      {
        label: "Empresa",
        field: "empresa",
      },
      {
        label: "Fecha",
        field: "fechaC",
      },
      {
        label: "Fecha de pago",
        field: "fechaP",
      },
      {
        label: "Vendedor",
        field: "vendedor",
      },
      {
        label: "Cliente",
        field: "cliente",
      },
      {
        label: "Titular",
        field: "titular",
      },
      {
        label: "Método",
        field: "metodo",
      },
      {
        label: "Monto",
        field: "monto",
      },
      {
        label: "Referencia",
        field: "referencia",
      },
      {
        label: "Nro. Cobro",
        field: "nroCobro",
      },
      {
        label: "Nro. ADEL",
        field: "nroADEL",
      },
      {
        label: "Facturas",
        field: "facturas",
      },
      {
        label: "Descripción",
        field: "descripcion",
      },
      {
        label: "Estatus",
        field: "estatus",
      },
    ],
    pagination: {
      sortBy: 'fechaC', // The field that you're sorting by
      descending: true
    },
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    modal: false,
    search: "",
    form: {
      nro: "",
      nroCobro: "",
      nroADEL: "",
      titular: "",
      empresa: "",
      vendedor: "",
      cliente: {},
      facturas: [],
      monto: null,
      tasa: null,
      descripcion: "",
      bauche: "",
      bauche2: "",
      metodo: "",
      referencia: "",
      observacion: "",
      estatus: "",
      fechaP: "",
      fechaC: ""
    },
    dialog: false,
    resultadosres: [],
    resultados: [],
    headers: [
      { text: "Nro", value: "nro" },
      { text: "Empresa", value: "empresa" },
      { text: "Fecha", value: "fechaC" },
      { text: "Fecha de pago", value: "fechaP" },
      { text: "Vendedor", value: "vendedor" },
      { text: "Cliente", value: "cliente.cli_des" },
      { text: "Método", value: "metodo" },
      { text: "Monto", value: "monto" },
      { text: "Referencia", value: "referencia" },
      { text: "Nro. Cobro", value: "nroCobro" },
      { text: "Estatus", value: "estatus" },
      { text: "Acción" }
    ],
    defaultForm: {
      nro: "",
      nroCobro: "",
      nroADEL: "",
      empresa: "",
      titular: "",
      vendedor: "",
      cliente: {},
      facturas: [],
      monto: null,
      tasa: null,
      descripcion: "",
      bauche: "",
      bauche2: "",
      metodo: "",
      referencia: "",
      observacion: "",
      estatus: "",
      fechaP: "",
      fechaC: ""
    },
    cre: "",
    mod: "",
    elm: "",
    img: ""
  }),
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    },
    dateRangeText () {
      let todos = []
      let desde
      let hasta
      if (this.dates && this.dates[0])  {
        desde = this.formatDate(this.dates[0])
        todos.push(desde)
      }
      if (this.dates && this.dates[1]) {
        hasta = this.formatDate(this.dates[1])
        todos.push(hasta)
      }
      return todos.join(' ~ ')
    },
  },
  watch: {
    dates (val) {
      if (val && val.length > 2) {
        let res = []
        res.push(val[0])
        res.push(val[2])
        this.$nextTick(() => {
          this.dates = res
        })
      }
      if (val && val.length == 2 && val[0] > val[1]) {
        this.$swal.fire(
          "¡Atención!",
          "La fecha final debe ser mayor a la fecha inicial.",
          "error"
        );
        let res = []
        res.push(val[0])
        this.$nextTick(() => {
          this.dates = res
        })
      }
    },
    date () {
      this.dateFormatted = this.formatDate(this.date)
    },
  },
  created() {
    let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
    let hasta = this.$moment().format('YYYY-MM-DD')
    this.dates.push(desde)
    this.dates.push(hasta)
    this.verificacion();
    this.initialize();
  },
  methods: {
    closeMov() {
      this.itemMov = null;
      this.typeMov = null;
      this.selectMov = [];
      this.resultadosMov = [];
      this.dialog7 = false;
    },
    buscarMovAso(item, type) {
      this.itemMov = item;
      this.typeMov = type;
      this.selectMov = [];
      this.resultadosMov = [];
      this.dialog7 = true;
      this.dialog4 = true;
      Api.get(`movimientos/coincidencias?fecha=${item.fechaP}&banco=${item.metodo}&monto=${item.monto}&ref=${item.referencia}`).then(res => {
        this.resultadosMov = res.data;
        this.dialog4 = false;
      }).catch(err=>{
        console.log(err)
        this.$swal.fire(
          "¡Atención!",
          err,
          "error"
        );
        this.dialog4 = false;
      });
    },
    buscarTodosMov() {
      Api.get(`movimientos/pendientes`).then(res => {
        this.resultadosMovAll = res.data;
        this.resultadosres.forEach(el => {
          this.resultadosMovAll.forEach(mov => {
            if (
              mov.banco === el.metodo &&
              parseFloat(mov.monto) === parseFloat(el.monto) &&
              this.$moment(mov.fecha).utc().format('DD/MM/YYYY') === this.$moment(el.fechaP).utc().format('DD/MM/YYYY')
            ) {
              el.coincide = true;
            }
          });
        });
        this.resultados.forEach(el => {
          this.resultadosMovAll.forEach(mov => {
            if (
              mov.banco === el.metodo &&
              parseFloat(mov.monto) === parseFloat(el.monto) &&
              this.$moment(mov.fecha).utc().format('DD/MM/YYYY') === this.$moment(el.fechaP).utc().format('DD/MM/YYYY')
            ) {
              el.coincide = true;
            }
          });
        });
      })
    },
    transform2(date) {
      return this.$moment(date).format("DD/MM/YYYY H:mm A")
    },
    editItemAproMov() {
      if (this.selectMov && this.selectMov.length > 0) {
        Object.keys(this.form).map(key => {
          if (this.itemMov[key]) this.form[key] = this.itemMov[key];
        });
        this.itemsF = []
        this.form.facturas = []
        for (let i = 0; i < this.itemMov.facturas.length; i++) {
          const el = this.itemMov.facturas[i];
          this.itemsF.push({
            value: el.nro_doc,
            text: el.nro_doc
          })
          this.form.facturas.push(el.nro_doc)
        }
        this.form._id = this.itemMov._id;
        this.save(this.typeMov, this.selectMov)
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debe seleccionar un movimiento para continuar",
          "error"
        );
      }
    },
    editItem3(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      if (this.form.fechaC) this.form.fechaC = this.$moment(this.form.fechaC).format('DD-MM-YYYY')
      this.form.fact = ""
      if (item.facturas && item.facturas.length > 0) {
        for (let i = 0; i < item.facturas.length; i++) {
          let el = item.facturas[i];
          if (i == (item.facturas.length - 1)) {
            this.form.fact += el.nro_doc.trim()
          } else this.form.fact += el.nro_doc.trim()+", "
        }
      }
      this.form._id = item._id;
      this.dialog3 = true;
    },
    imprimirPdf () {
      printJS({
        printable: 'printJS-form',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        css: 'printPdf'
      })
    },
    close3() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog3 = false;
    },
    transform(date) {
      return this.$moment(date).utc().format("DD/MM/YYYY")
    },
    cambiarFiltro() {
      let data = this.seleccionFiltro
      if (data) {
        this.resultados = []
        this.dataExcel = []
        let res = []
        for (let i = 0; i < this.resultadosres.length; i++) {
          const el = this.resultadosres[i];
          let fcct = ""
          for (let j = 0; j < el.facturas.length; j++) {
            const el2 = el.facturas[j];
            if (i == (el.facturas.length-1)) {
              fcct += el2.nro_doc.trim() + "."
            } else fcct += el2.nro_doc.trim() + ", "
          }
          if (data === "todos") {
            res.push(el)
            this.dataExcel.push({
              nro: el.nro,
              empresa: el.empresa ? el.empresa : "N/A",
              fechaC: this.$moment(el.fechaC).format('DD-MM-YYYY H:mm A'),
              fechaP: this.$moment(el.fechaP).format('DD-MM-YYYY H:mm A'),
              vendedor: el.vendedor,
              cliente: el.cliente.cli_des,
              titular: el.titular ? el.titular : "N/A",
              metodo: el.metodo,
              monto: el.monto,
              referencia: (el.referencia) ? el.referencia : "N/A",
              nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
              nroADEL: (el.nroADEL) ? el.nroADEL : "N/A",
              facturas: fcct,
              descripcion: el.descripcion,
              estatus: el.estatus
            })
          } else if (el.estatus === data) {
            res.push(el)
            this.dataExcel.push({
              nro: el.nro,
              empresa: el.empresa ? el.empresa : "N/A",
              fechaC: this.$moment(el.fechaC).format('DD-MM-YYYY H:mm A'),
              fechaP: this.$moment(el.fechaP).format('DD-MM-YYYY H:mm A'),
              vendedor: el.vendedor,
              cliente: el.cliente.cli_des,
              titular: el.titular ? el.titular : "N/A",
              metodo: el.metodo,
              monto: el.monto,
              referencia: (el.referencia) ? el.referencia : "N/A",
              nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
              nroADEL: (el.nroADEL) ? el.nroADEL : "N/A",
              facturas: fcct,
              descripcion: el.descripcion,
              estatus: el.estatus
            })
          }
        }
        this.$nextTick(() => {
          this.resultados = res
        })
      }
    },
    verificacion() {
      for (let i = 0; i < this.$store.state.adminitalven.permisos.length; i++) {
        if (this.$store.state.adminitalven.permisos[i].ruta === "Cobros") {
          for (
            let j = 0;
            j < this.$store.state.adminitalven.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminitalven.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminitalven.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminitalven.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    formatDate (date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null
      const [day, month, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    buscarFecha() {
      this.dialog4 = true
      let hasta = (this.dates && this.dates[1]) ? this.dates[1] : null
      if (this.dates && this.dates[0]) {
        Api.get("cobros/admin?desde="+this.dates[0]+'&hasta='+hasta)
        .then(res => {
          this.dialog4 = false
          this.resultados = [];
          this.resultadosres = [];
          this.dataExcel = []
          if (res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              const el = res.data[i];
              if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
              let fact = []
              for (let j = 0; j < el.facturas.length; j++) {
                const el2 = el.facturas[j];
                if (typeof el2 === "string") {
                  fact = JSON.parse(el2)
                } else fact.push(el2)
              }
              el.coincide = false;
              el.facturas = fact
              let fcct = ""
              for (let j = 0; j < el.facturas.length; j++) {
                const el2 = el.facturas[j];
                if (i == (el.facturas.length-1)) {
                  fcct += el2.nro_doc.trim() + "."
                } else fcct += el2.nro_doc.trim() + ", "
              }
              this.resultados.push(el)
              this.resultadosres.push(el)
              this.dataExcel.push({
                nro: el.nro,
                empresa: el.empresa ? el.empresa : "N/A",
                fechaC: this.$moment(el.fechaC).utc().format('DD-MM-YYYY H:mm A'),
                fechaP: this.$moment(el.fechaP).utc().format('DD-MM-YYYY H:mm A'),
                vendedor: el.vendedor,
                cliente: el.cliente.cli_des,
                titular: el.titular ? el.titular : "N/A",
                metodo: el.metodo,
                monto: el.monto,
                referencia: (el.referencia) ? el.referencia : "N/A",
                nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
                nroADEL: (el.nroADEL) ? el.nroADEL : "N/A",
                facturas: fcct,
                descripcion: el.descripcion,
                estatus: el.estatus
              })
            }
            this.buscarTodosMov()
          }
        }).catch(err=>{
          console.log(err)
          this.dialog4 = false
        })
      } else {
        this.$swal.fire(
          "¡Atención!",
          "Debes seleccionar al menos una fecha para realizar la operación",
          "error"
        );
      }
    },
    initialize() {
      this.date = new Date().toISOString().substr(0, 10)
      this.dateFormatted = this.formatDate(new Date().toISOString().substr(0, 10))
      this.dates = []
      let desde = this.$moment().subtract(1, "d").format('YYYY-MM-DD')
      let hasta = this.$moment().format('YYYY-MM-DD')
      this.dates.push(desde)
      this.dates.push(hasta)
      this.dataExcel = []
      Api.get("cobros/admin?desde="+this.dates[0]+'&hasta='+this.dates[1]).then(res => {
        this.resultados = []
        this.resultadosres = []
        if (res.data && res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            const el = res.data[i];
            if (typeof el.cliente === "string") el.cliente = JSON.parse(el.cliente)
            let fact = []
            for (let j = 0; j < el.facturas.length; j++) {
              const el2 = el.facturas[j];
              if (typeof el2 === "string") {
                fact = JSON.parse(el2)
              } else fact.push(el2)
            }
            el.facturas = fact
            el.coincide = false;
            let fcct = ""
            for (let j = 0; j < el.facturas.length; j++) {
              const el2 = el.facturas[j];
              if (i == (el.facturas.length-1)) {
                fcct += el2.nro_doc.trim() + "."
              } else fcct += el2.nro_doc.trim() + ", "
            }
            this.resultados.push(el)
            this.resultadosres.push(el)
            this.dataExcel.push({
              nro: el.nro,
              empresa: el.empresa ? el.empresa : "N/A",
              fechaC: this.$moment(el.fechaC).utc().format('DD-MM-YYYY H:mm A'),
              fechaP: this.$moment(el.fechaP).utc().format('DD-MM-YYYY H:mm A'),
              vendedor: el.vendedor,
              cliente: el.cliente.cli_des,
              titular: el.titular ? el.titular : "N/A",
              metodo: el.metodo,
              monto: el.monto,
              referencia: (el.referencia) ? el.referencia : "N/A",
              nroCobro: (el.nroCobro) ? el.nroCobro : "N/A",
              nroADEL: (el.nroADEL) ? el.nroADEL : "N/A",
              facturas: fcct,
              descripcion: el.descripcion,
              estatus: el.estatus
            })
          }
          this.buscarTodosMov()
        }
      });
    },
    close2() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog2 = false;
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
    },
    editItem(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = []
      this.form.facturas = []
      for (let i = 0; i < item.facturas.length; i++) {
        const el = item.facturas[i];
        this.itemsF.push({
          value: el.nro_doc,
          text: el.nro_doc
        })
        this.form.facturas.push(el.nro_doc)
      }
      this.form._id = item._id;
      this.dialog = true;
    },
    editItem2(item) {
      Object.keys(this.form).map(key => {
        if (item[key]) this.form[key] = item[key];
      });
      this.itemsF = []
      this.form.facturas = []
      for (let i = 0; i < item.facturas.length; i++) {
        const el = item.facturas[i];
        this.itemsF.push({
          value: el.nro_doc,
          text: el.nro_doc
        })
        this.form.facturas.push(el.nro_doc)
      }
      this.form._id = item._id;
      this.dialog2 = true;
    },
    save2() {
      let info = {
        _id: this.form._id,
        monto: this.form.monto,
        referencia: this.form.referencia
      }
      this.loading = true;
      Api.put("cobros", info)
        .then(() => {
          this.form = Object.assign({}, this.defaultForm);
          this.dialog2 = false;
          this.$swal.fire(
            "Felicidades.!",
            "Modificación realizada exitosamente.",
            "success"
          );
          this.loading = false;
          this.buscarFecha();
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
          this.$swal.fire(
            "Oops...",
            "Error encontrado, verifique los datos o llame al administrador.",
            "error"
          );
      });
    },
    save(item, mov = null) {
      let info = {
        _id: this.form._id,
        referencia: mov && mov.length > 0 ? mov[0].referencia : this.form.referencia,
        referenciaOld: mov && mov.length > 0 ? this.form.referencia : null,
        mov: mov && mov.length > 0 ? mov[0] : null,
        empresa: this.form.empresa,
        estatus: (item === "A") ? "Aprobado" : (item === "P") ? "Procesado" : (item === "C") ? "Conciliado" : "Rechazado"
      }
      if (info.estatus === "Rechazado") {
        this.$swal.fire({
          title: 'Motivo del rechazo',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true
        }).then((result) => {
          if (result.isDismissed) {
            console.log("paso cancel")
          } else if (result.value) {
            info.observacion = result.value
            this.loading = true;
            Api.put("cobros", info)
              .then(() => {
                this.form = Object.assign({}, this.defaultForm);
                this.dialog = false;
                this.$swal.fire(
                  "Felicidades.!",
                  "Modificación realizada exitosamente.",
                  "success"
                );
                this.loading = false;
                this.buscarFecha();
              })
              .catch(err => {
                console.log(err);
                this.loading = false;
                this.$swal.fire(
                  "Oops...",
                  "Error encontrado, verifique los datos o llame al administrador.",
                  "error"
                );
            });
          } else {
            this.$swal.fire(
              "¡Atención!",
              "Debe ingresar el motivo del rechazo.",
              "error"
            );
          }
        })
      } else {
        this.loading = true;
        Api.put("cobros", info)
          .then(() => {
            this.closeMov();
            this.resultados.forEach(el=>{
              if (el._id.toString() == this.form._id.toString()) {
                el.estatus = info.estatus
                if (info.referencia) el.referencia = info.referencia
                if (info.referenciaOld) el.referenciaOld = info.referenciaOld
              }
            })
            this.resultadosres.forEach(el=>{
              if (el._id.toString() == this.form._id.toString()) {
                el.estatus = info.estatus
                if (info.referencia) el.referencia = info.referencia
                if (info.referenciaOld) el.referenciaOld = info.referenciaOld
              }
            })
            this.dataExcel.forEach(el=>{
              if (el.nro.toString() == this.form.nro.toString()) {
                el.estatus = info.estatus
                if (info.referencia) el.referencia = info.referencia
                if (info.referenciaOld) el.referenciaOld = info.referenciaOld
              }
            })
            this.form = Object.assign({}, this.defaultForm);
            this.dialog = false;
            this.$swal.fire(
              "Felicidades.!",
              "Modificación realizada exitosamente.",
              "success"
            );
            this.loading = false;
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
            this.$swal.fire(
              "Oops...",
              "Error encontrado, verifique los datos o llame al administrador.",
              "error"
            );
        });
      }
    }
  }
};
</script>
<style lang="scss">
.printPdf {
    @page :footer {
        display: none
    }
 
    @page :header {
        display: none
    }
}
.borderTb {
  border: 1px solid;
  text-align: center;
  width: 160px;
}
.withTd {
  width: 160px;
}
.textGrn {
  width: 100%;
  text-align: center;
}
.withTd2 {
  border: 2px solid;
  padding: 4px;
  font-weight: bold;
}
.withTd3 {
  padding: 4px;
  font-weight: bold;
}
.paddText {
  padding-right: 10px;
  font-size: 14px;
  font-weight: bold;
}
.divRect {
  width: 100px;
  height: 30px;
  border: 2px solid;
}
.divPrin {
  display: flex;
  align-items: center;
}
.divProd {
  background-color: gainsboro !important;
  font-weight: 400;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.divCli {
  margin-top: 20px;
  background-color: gainsboro !important;
  font-weight: 400;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#printJS-form {
  table, th, td {
    border-collapse: collapse;
  }
}
</style>
